
var printButtons = document.querySelectorAll('#printButton');

printButtons.forEach(function(button) {
  button.addEventListener('click', function() {
    window.print();
  });
});